import { detect } from 'detect-browser';
import isUaWebview from 'is-ua-webview';
import { createAction } from 'redux-actions';
import { v4 as uuidv4 } from 'uuid';
import { actionTypes } from './index';
import { infoLaunch } from '../api/info';
import { checkAppMinVersionSupport } from '../api/users';
import { appVersion } from '../utils/consts';
import { addNotification } from './api-notifications';

const applicationSetDetected = createAction(actionTypes.APPLICATION_SET_DETECTED);

// eslint-disable-next-line import/prefer-default-export
export function applicationCheckOS() {
  return (dispatch) => {
    const detected = detect();

    dispatch(applicationSetDetected({
      detected,
      isWebview: isUaWebview(navigator.userAgent),
    }));
  };
}

export function applicationInitialise() {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.APPLICATION_INITIALISE_REQUEST,
      });

      dispatch(getInfoLaunch());
    } catch (error) {
      addNotification({
        id: uuidv4(),
        message: 'Cannot initialise application data!',
      });

      dispatch(applicationInitialiseFailure(error.message));

      throw error;
    }
  };
}

export function getInfoLaunch() {
  return async (dispatch) => {
    try {
      const launchData = await infoLaunch();

      dispatch(applicationInitialiseSuccess(launchData));
    } catch (error) {
      addNotification({
        id: uuidv4(),
        message: 'Cannot get Launch data!',
      });

      dispatch(applicationInitialiseFailure(error.message));

      throw error;
    }
  };
}

export function checkVersionSupport() {
  return async (dispatch, getState) => {
    try {
      const supported = await checkAppMinVersionSupport('WEB', appVersion);
      const shouldUpdate = !supported;
      (shouldUpdate !== getState().application.applicationShouldUpdate)
      && dispatch(setApplicationShouldUpdateSuccess(shouldUpdate));
    } catch (error) {
      (error.message !== getState().application.error)
      && dispatch(setApplicationShouldUpdateFailure(error.message));
    }
  };
}

function applicationInitialiseSuccess(launchData) {
  return {
    type: actionTypes.APPLICATION_INITIALISE_SUCCESS,
    payload: { launchData },
  };
}

function applicationInitialiseFailure(error) {
  return {
    error,
    type: actionTypes.APPLICATION_INITIALISE_FAILURE,
  };
}

export function setApplicationShouldUpdateSuccess(shouldUpdate) {
  return {
    type: actionTypes.SET_APPLICATION_SHOULD_UPDATE_SUCCESS,
    payload: shouldUpdate,
  };
}

function setApplicationShouldUpdateFailure(error) {
  return {
    error,
    type: actionTypes.SET_APPLICATION_SHOULD_UPDATE_FAILURE,
  };
}



// WEBPACK FOOTER //
// ./actions/application.js